import FetchInterceptor from "configs/FetchInterceptor";

class PurchaseHistoryServices {
  static async getAllPriceHistory(requestBody) {
    const apiUrl = "/core/v1/purchase/history/buying-price/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }
}

export default PurchaseHistoryServices;
